import { useState } from "react";
import api from "../api/axios";
import { saveAuth } from "../auth/auth";
import { useNavigate, Link } from "react-router-dom";
import AlertBox from "../components/AlertBox";
import { useTranslation } from "react-i18next"; // <-- استدعاء الترجمة

export default function Login() {
    const { t } = useTranslation(); // <-- تفعيل الترجمة

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const nav = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);

        try {
            const res = await api.post("/login", { email, password });
            const payload = res.data.data ?? res.data;
            saveAuth(payload);
            const user = payload.user;

            if (user?.role === "admin") {
                nav("/admin/dashboard");
            } else {
                nav("/");
            }
        } catch (e) {
            const data = e.response?.data;
            if (data?.errors) {
                const firstKey = Object.keys(data.errors)[0];
                setErr(data.errors[firstKey][0]);
            } else {
                setErr(t("login_failed")); // <-- ترجمة رسالة الخطأ
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container my-5">
            <div className="row border rounded-4 shadow-sm overflow-hidden bg-white mx-auto" style={{ maxWidth: "900px" }}>

                {/* العمود الأيسر: تصميم دعائي */}
                <div className="col-md-6 d-none d-md-flex flex-column justify-content-center align-items-center p-5 text-white"
                    style={{ background: "linear-gradient(135deg, #0d6efd 0%, #0dcaf0 100%)" }}>
                    <i className="bi bi-cart-check display-1 mb-4 opacity-75"></i>
                    <h2 className="fw-bold mb-3 text-center">{t("welcome_back")}</h2>
                    <p className="fs-5 text-center text-white-50">
                        {t("login_promo_text")}
                    </p>
                </div>

                {/* العمود الأيمن: نموذج تسجيل الدخول */}
                <div className="col-md-6 p-4 p-md-5">
                    <div className="text-center mb-4">
                        <h3 className="fw-bold text-primary">{t("login_title")}</h3>
                        <p className="text-muted">{t("login_subtitle")}</p>
                    </div>

                    <AlertBox type="danger" message={err} onClose={() => setErr("")} />

                    <form onSubmit={submit}>
                        {/* البريد الإلكتروني */}
                        <div className="mb-3">
                            <label className="form-label fw-bold small text-muted">{t("email_label")}</label>
                            <div className="input-group">
                                <span className="input-group-text bg-light text-muted border-end-0">
                                    <i className="bi bi-envelope"></i>
                                </span>
                                <input
                                    type="email"
                                    className="form-control border-start-0 ps-0 focus-none"
                                    placeholder="example@email.com"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        {/* كلمة المرور */}
                        <div className="mb-4">
                            <label className="form-label fw-bold small text-muted">{t("password_label")}</label>
                            <div className="input-group">
                                <span className="input-group-text bg-light text-muted border-end-0">
                                    <i className="bi bi-lock"></i>
                                </span>
                                <input
                                    type="password"
                                    className="form-control border-start-0 ps-0 focus-none"
                                    placeholder="********"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                        </div>

                        {/* زر تسجيل الدخول */}
                        <button className="btn btn-primary w-100 py-2 fw-bold shadow-sm" disabled={loading}>
                            {loading ? (
                                <><span className="spinner-border spinner-border-sm me-2"></span> {t("logging_in")}</>
                            ) : (
                                <><i className="bi bi-box-arrow-in-right me-2"></i> {t("login_title")}</>
                            )}
                        </button>
                    </form>

                    <div className="text-center mt-4 border-top pt-3">
                        <span className="text-muted small">{t("no_account")}</span>
                        <Link to="/register" className="text-decoration-none fw-bold small">
                            {t("create_new_account")}
                        </Link>
                    </div>
                </div>
            </div>

            <style>{`
                .focus-none:focus { box-shadow: none; border-color: #dee2e6; }
                .input-group:focus-within { box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25); border-radius: 0.375rem; }
                .input-group:focus-within .input-group-text, .input-group:focus-within .form-control { border-color: #86b7fe; }
            `}</style>
        </div>
    );
}